import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
} from '@chakra-ui/react';
import { FC, useRef } from 'react';

type AlertDialogComponent = Partial<AlertDialogProps> & {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  headerTitle?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'red' | 'blue' | 'green' | 'yellow';
};

const AlertDialogComponent: FC<AlertDialogComponent> = ({
  isOpen,
  onClose,
  onConfirm,
  headerTitle,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'red',
  ...rest
}) => {
  const cancelRef = useRef(null);

  return (
    <>
      <AlertDialog
        {...rest}
        isOpen={isOpen}
        onClose={onClose}
        leastDestructiveRef={cancelRef}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            {headerTitle && (
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {headerTitle}
              </AlertDialogHeader>
            )}

            <AlertDialogBody>{message}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                {cancelText}
              </Button>
              <Button colorScheme={variant} onClick={onConfirm} ml={3}>
                {confirmText}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default AlertDialogComponent;
